import { ChangeColor } from './ChangeColor';

export class ChangeTextOnLightColor extends ChangeColor {
  type: string = 'ChangeTextOnLightColor';
}
